import _export from '../internals/export.js';
import functionUncurryThis from '../internals/function-uncurry-this.js';
import '../internals/object-get-own-property-descriptor.js';
import toLength$1 from '../internals/to-length.js';
import toString$1 from '../internals/to-string.js';
import notARegexp from '../internals/not-a-regexp.js';
import requireObjectCoercible$1 from '../internals/require-object-coercible.js';
import correctIsRegexpLogic from '../internals/correct-is-regexp-logic.js';
import { __exports as objectGetOwnPropertyDescriptor } from '../../../../../../_virtual/object-get-own-property-descriptor.js';

var $ = _export;
var uncurryThis = functionUncurryThis;
var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$1;
var toString = toString$1;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$1;
var correctIsRegExpLogic = correctIsRegexpLogic;

var un$StartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;
var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith'); // https://github.com/zloirock/core-js/pull/702

var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}(); // `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith

$({
  target: 'String',
  proto: true,
  forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
}, {
  startsWith: function startsWith(searchString
  /* , position = 0 */
  ) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return un$StartsWith ? un$StartsWith(that, search, index) : stringSlice(that, index, index + search.length) === search;
  }
});
